<template>
  <div>
    <template
      v-if="serviceDates.length > 0 && serviceHours.length > 0 && !loading"
    >
      <div
        class="container"
        :style="
          isSmallDevice
            ? `max-height: calc(100vh - 420px);`
            : `max-height: calc(100vh - 400px);`
        "
      >
        <b-row class="date-time-step-content"
        >
          <b-col
            class="d-flex justify-content-center align-items-center"
            sm="12"
            md="5"
          >
            <div class="parent-height-as-max-height">
              <b-calendar
                selected-variant="success"
                today-variant="info"
                nav-button-variant="primary"
                v-model="selectedDate"
                :locale="$i18n.locale"
                :date-disabled-fn="dateDisabled"
                @selected="selectDate"
              ></b-calendar>
            </div>
          </b-col>
          <b-col
            class="scroll-content-list d-flex justify-content-center align-items-center h-100"
            sm="12"
            md="7"
          >
            <div
              class="parent-height-as-max-height"
              style="color: #C7C7C7;"
            >
              <span v-if="!selectedDate">
                {{ $t("step-no-date-selected") }}
              </span>
              <b-container v-if="selectedDate">
                <b-row>
                  <b-col
                    v-for="(slot, index) in serviceHours"
                    :key="index"
                    :cols="serviceHours.length === 1 || isSmallDevice ? 12 : 6"
                    style="padding-right: 20px; padding-left: 20px;"
                  >
                    <div
                      class="item-card d-flex justify-content-between align-items-center mt-2 mb-3 p-2 gap-10"
                    >
                      <span>
                        {{ formatHour(slot.hour) }}
                      </span>
                      <button
                        @click="selectHour(slot)"
                        class=" btn btn-primary btn-select text-uppercase text"
                      >
                        Select
                      </button>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-else>
      <div
        class="container d-flex justify-content-center align-items-center text-center h-50 flex-column"
      >
        <div v-if="loading">
          <b-spinner
            style="width: 4rem; height: 4rem"
            variant="primary"
            label="Loading..."
          />
        </div>

        <div v-else>
          <h3>{{ getIsEmptyMessage }}</h3>

          <b-button
            class="mt-5"
            size="md"
            variant="primary"
            @click="goBack"
            style="width: 100px;"
          >
            Go back
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import {
  formatDateOnlyMysql,
  formatTimeOnly
} from "../../../../../Breeze.FormBuilder.Frontend/helpers/date";
export default {
  name: "AppointmentDateTimeStep",
  props: ["isSmallDevice", "serviceDates", "serviceHours", "config", "loading"],
  data() {
    return {
      selectedDate: null,
      today: formatDateOnlyMysql(new Date()),
      disabledDate: !this.config.appointmentRequestNewClientScheduleSameDay
    };
  },
  methods: {
    initDate() {
      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      if (this.serviceDates.length == 0) {
        return currentDate;
      }

      const servicesDates = this.serviceDates.map(d => moment(d.hour).toDate());

      servicesDates.sort((a, b) => a - b);

      for (let index = 0; index < servicesDates.length; index++) {
        const servicesDate = servicesDates[index];
        if (
          servicesDate.getTime() === currentDate.getTime() &&
          !this.disabledDate
        ) {
          return currentDate;
        }
        if (servicesDate > currentDate) {
          return servicesDate;
        }
      }
      return currentDate;
    },
    selectDate() {
      if (!(this.selectedDate instanceof Date)) {
        this.selectedDate = new Date(this.selectedDate + "T00:00:00");
      }
      this.$emit("setDate", this.selectedDate);
    },
    selectHour(data) {
      this.$emit("select", data);
    },
    dateDisabled(ymd, date) {
      const calendarDate = date.toISOString().slice(0, 10);
      for (let index = 0; index < this.serviceDates.length; index++) {
        const element = this.serviceDates[index].hour;
        if (calendarDate < this.today) {
          return true;
        }
        if (element === calendarDate) {
          if (calendarDate === this.today && this.disabledDate) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
    formatHour(input) {
      return formatTimeOnly(input, "HH:mm");
    },
    goBack() {
      this.$emit("back");
    }
  },
  mounted() {
    this.selectedDate = this.initDate();
    this.selectDate();
  },
  computed: {
    getIsEmptyMessage() {
      return "No dates available, please change your selection and try again.";
    }
  }
};
</script>

<style scoped lang="scss">
.item-card {
  background-color: #fff;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: #808080;
  // margin: 8px;
  font-size: 0.8rem;
  overflow: hidden;
  position: relative;
}

.date-time-step-content {
  height: 400px;
}

.gap-10 {
  gap: 10px;
}

.padding-20 {
  padding: 20px;
}

.btn-select {
  font-size: 0.8rem;
}
.scroll-content,
.scroll-content-list {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: auto;
}

.scroll-content::-webkit-scrollbar {
  display: none;
}
.scroll-content-list::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #dfe6e9;
}
.scroll-content-list::-webkit-scrollbar-thumb {
  background-color: #2196f3;
  border-radius: 10px;
}

.parent-height-as-max-height {
  max-height: 100%;
}
</style>
